var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-background-animations",attrs:{"id":"ui-background-animations"}},[(_vm.blob)?_c('BlobSnowflakes'):_vm._e(),(_vm.animateTachyons)?_c('TachyonParticles'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }